export default __webpack_public_path__ + "static/media/8.f8a00203.png";